/**
 * Canonical NAP (Name / Address / Phone) facts for Kinship Care Collective.
 *
 * Local search ranking depends on these strings matching EXACTLY everywhere —
 * on this site, in schema markup, in the Google Business Profile, and in any
 * directory citation. Never abbreviate, reformat, or paraphrase them locally;
 * import from here instead.
 */

/** Exact legal/brand name. No abbreviations, no "KCC". */
export const BUSINESS_NAME = "Kinship Care Collective";

/** Display phone — the only accepted formatting. */
export const PHONE_DISPLAY = "(615) 807-0618";

/** E.164 phone for tel: links and schema. */
export const PHONE_TEL = "+16158070618";
export const PHONE_HREF = `tel:${PHONE_TEL}`;
export const PHONE_SCHEMA = "+1-615-807-0618";

export const EMAIL = "hello@kinshipcarecollective.com";
export const SITE_URL = "https://www.kinshipcarecollective.com";

/** Primary service-area cities, in this order, everywhere. */
export const SERVICE_AREA_CITIES = ["Nashville", "Brentwood", "Franklin", "Belle Meade"] as const;

/** Canonical service-area sentence fragment. */
export const SERVICE_AREA_TEXT = "Nashville, Brentwood, Franklin, and Belle Meade, TN";

/** Canonical service-area sentence including the wider radius. */
export const SERVICE_AREA_TEXT_EXTENDED =
  "Nashville, Brentwood, Franklin, and Belle Meade, TN — plus surrounding Middle Tennessee communities";

/** Service-area business: no walk-in address is published. */
export const HAS_PUBLIC_STREET_ADDRESS = false;

export const BUSINESS_CATEGORY = "Non-medical companion and senior care";

/**
 * Google Business Profile.
 *
 * Public GBP review link (opens the write-a-review form). Everything on the
 * site that asks for a review reads from this constant.
 */
export const GOOGLE_BUSINESS_PROFILE_URL =
  "https://www.google.com/maps/place//data=!4m3!3m2!1s0x85669135a4b576b:0xc7b7520d083c9680!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2";

/** Placeholder embed: greater Nashville service radius until the GBP place ID is available. */
export const GOOGLE_MAPS_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206252.72681975925!2d-86.9619!3d36.1627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8864ec3213eb903d%3A0x7d3fb9d0a1e9daa0!2sNashville%2C%20TN!5e0!3m2!1sen!2sus!4v1700000000000";
